import { render, staticRenderFns } from "./AxFilesystemTable.vue?vue&type=template&id=46cb2396&"
import script from "./AxFilesystemTable.vue?vue&type=script&lang=ts&"
export * from "./AxFilesystemTable.vue?vue&type=script&lang=ts&"
import style0 from "./AxFilesystemTable.vue?vue&type=style&index=0&id=46cb2396&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports